export const FeatureName = 'accounting';
